import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import PencilIcon from "assets/icons/pencil.svg";
import InputPicture from "core/inputs/input-picture/InputPicture";
import InputText from "core/inputs/input-text/InputText";
import { Typography } from "core/typography/Typography";
import { Controller } from "utils/Controller";
import {
  DELIVERY_NOTE_FORM_LABELS,
  DELIVERY_NOTE_FORM_PLACEHOLDERS,
} from "constants/forms";

const SignatoriesBlock = ({
  control,
  register,
  watch,
  setCode,
  setStatus,
  onImageChange,
  resolveImage,
}) => {
  const renderSignature = ({ party, field, label, defaultMessage }) => (
    <InputPicture
      id={`delivery-note-${party}-signature`}
      label={{ id: label, defaultMessage }}
      value={resolveImage(watch(field))}
      onChange={(file) => onImageChange(field, file)}
      placeholderIcon={PencilIcon}
      setCode={setCode}
      setStatus={setStatus}
    />
  );

  const renderSignatoryName = (party) => (
    <Controller
      control={control}
      register={register}
      name={`${party}_signatory_name`}
      render={(props) => (
        <InputText
          id={`delivery-note-${party}-signatory`}
          label={DELIVERY_NOTE_FORM_LABELS[`${party}_signatory`]}
          placeholder={DELIVERY_NOTE_FORM_PLACEHOLDERS.signatory}
          {...props}
        />
      )}
    />
  );

  return (
    <div className="delivery-note-form__section">
      <Typography
        className="title-3 violet text-uppercase"
        type="h2"
        label={
          <FormattedMessage
            id="delivery_note_signatories_block"
            defaultMessage="Signataires"
          />
        }
      />
      <div className="delivery-note-party delivery-note-party--signatories">
        <div className="corner-left">
          {renderSignature({
            party: "issuer",
            field: "issuer_signature_file_id",
            label: "delivery_note_issuer_signature",
            defaultMessage: "Signature émetteur",
          })}
        </div>
        <div className="center-block">
          <div className="cell-padding">{renderSignatoryName("issuer")}</div>
        </div>
        <div className="corner-left corner-left--inner">
          {renderSignature({
            party: "recipient",
            field: "recipient_signature_file_id",
            label: "delivery_note_recipient_signature",
            defaultMessage: "Signature réception",
          })}
        </div>
        <div className="corner-right">{renderSignatoryName("recipient")}</div>
      </div>
    </div>
  );
};

SignatoriesBlock.propTypes = {
  control: PropTypes.object.isRequired,
  register: PropTypes.func.isRequired,
  watch: PropTypes.func.isRequired,
  setCode: PropTypes.func,
  setStatus: PropTypes.func,
  onImageChange: PropTypes.func.isRequired,
  resolveImage: PropTypes.func.isRequired,
};

export default SignatoriesBlock;
